<template>
  <v-app>
    <Header v-if="logged" class="d-print-none" />
    <div class="d-flex">
      <SideBar v-if="logged" class="d-print-none" />
      <div
        id="routes"
        :class="`${(logged ? '' : 'pagesOnlyBody', !isCollapsed ? 'menu-expanded' : 'menu-collapsed')} px-4 pt-3`"
      >
        <router-view />
        <div class="mt30"></div>
        <Footer v-if="logged" class="d-print-none" />
      </div>
    </div>
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Header from './components/Header';
import SideBar from './components/SideBar';
import Footer from './components/Footer';
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    SideBar
  },
  data: () => ({}),
  computed: {
    ...mapState('LoginStore', ['logged']),
    ...mapGetters('SidebarStore', ['isCollapsed'])
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
#routes {
  transition: margin 0.3s ease;
  margin-top: 70px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;

  &.menu-expanded {
    margin-left: 220px;
  }
  &.menu-collapsed {
    margin-left: 50px;
  }
}
</style>
